import { api, unwrap, type APIResponse } from "./client";

// Mirrors app/routers/notification.py NotificationOut.
export interface Notification {
  notification_id: number;
  title: string;
  body: string | null;
  level: string;
  is_active: boolean;
  created_at: string | null;
}

export interface NotificationInput {
  title: string;
  body: string | null;
  level: string;
  is_active: boolean;
}

export async function listNotifications(activeOnly?: boolean): Promise<Notification[]> {
  const resp = await api.get<APIResponse<Notification[]>>("/notifications/", {
    params: activeOnly ? { active_only: activeOnly } : undefined,
  });
  return unwrap(resp.data);
}

export async function createNotification(body: NotificationInput): Promise<number> {
  const resp = await api.post<APIResponse<{ notification_id: number }>>("/notifications/", body);
  return unwrap(resp.data).notification_id;
}

export async function updateNotification(id: number, body: NotificationInput): Promise<void> {
  await api.put(`/notifications/${id}`, body);
}

export async function deleteNotification(id: number): Promise<void> {
  await api.delete(`/notifications/${id}`);
}
